import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
export function setUserViewedTags(tags) {
  return {
    type: 'SET_USER_VIEWED_TAGS',
    tags: tags
  };
}
export function setUserViewedTagsFetchingStatus(fetching, fetched) {
  return {
    type: 'SET_USER_VIEWED_TAGS_FETCHING_STATUS',
    fetching: fetching,
    fetched: fetched
  };
}
export function fetchUserViewedTags() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var cookies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'include';
  return function (dispatch) {
    return Promise.all([dispatch(setUserViewedTagsFetchingStatus(true, true))]).then(function () {
      return finectAPI({
        version: 'v4',
        path: "users/me/viewed/tags?limit=".concat(limit),
        method: 'GET',
        credentials: cookies,
        onSuccess: function onSuccess(_ref) {
          var data = _ref.data;
          return dispatch(setUserViewedTags(data));
        }
      });
    });
  };
}
export function setUserViewedProducts(products) {
  return {
    type: 'SET_USER_VIEWED_PRODUCTS',
    products: products
  };
}
export function setUserViewedProductsFetchingStatus(fetching, fetched) {
  return {
    type: 'SET_USER_VIEWED_PRODUCTS_FETCHING_STATUS',
    fetching: fetching,
    fetched: fetched
  };
}
export function fetchUserViewedProducts() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var cookies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'include';
  return function (dispatch) {
    return Promise.all([dispatch(setUserViewedProductsFetchingStatus(true, true))]).then(function () {
      return finectAPI({
        version: 'v4',
        path: "users/me/viewed/products?limit=".concat(limit),
        method: 'GET',
        credentials: cookies,
        onSuccess: function onSuccess(_ref2) {
          var data = _ref2.data;
          return dispatch(setUserViewedProducts(data));
        }
      });
    });
  };
}